import { useResponsive } from 'imports/core/api/responsiveContext';
import dynamic from 'next/dynamic';
import { Fragment } from 'react';

const RenderLandingMultipleTests = dynamic(() => import('/imports/landing/ui/components/RenderLandingMultipleTests'), {
  ssr: false,
});

const MainLandingPageDynamic = dynamic(() => import('/imports/AutoApply/ui/page/MainLandingPage'), {
  ssr: false,
});

const HelpPage = dynamic(() => import('/imports/help/ui/pages/HelpPage'), {
  ssr: false,
});

const HelpBridge = (props) => {
  const { host } = useResponsive();
  const url = window.location.hostname;
  const help = url.split('.');
  if (!help.includes('help')) {
    if (['bluepill', 'applycator', 'autoapply'].includes(host)) {
      return (
        <Fragment>
          <MainLandingPageDynamic {...props} />
        </Fragment>
      );
    } else {
      return <RenderLandingMultipleTests {...props} />;
    }
  } else return <HelpPage />;
};

export default HelpBridge;
